/* eslint-disable linebreak-style */
export default function ({ store, redirect, route }) {
    const noAuthUrl = ['register', 'login', 'reset-password'];
    if ((!noAuthUrl.includes(route.name) && store.state.user === null)
        || (noAuthUrl.includes(route.name) && store.state.user !== null)) {
        return redirect('/');
    }
}
